const LeftToRightListStar01Icon = /*#__PURE__*/ [
  ["path", { d: "M3 5.5L12 5.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 12L12 12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 18.5L12 18.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21 5.5H16M17.0417 8L19.9583 3M19.9583 8L17.0417 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M21 18.5H16M17.0417 21L19.9583 16M19.9583 21L17.0417 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export { LeftToRightListStar01Icon as default };
//# sourceMappingURL=LeftToRightListStar01Icon.js.map
